import React from "react";
import { GetMoneyValue } from "../../../../../Api/ApiCommon";
import { PayInfoDetailProps } from "../PayInfoDetail";
import {
  PayDetailItem,
  PayDetailItemChildText,
  PayDetailItemGrayText,
  PayDetailItemText,
} from "./PartyFeePay";

export default function PartyEndRewExit({ data }: PayInfoDetailProps) {
  return (
    <>
      {/* label */}
      <PayDetailItem>
        <PayDetailItemText>잔여 파티 요금 환급</PayDetailItemText>
        <>
          <PayDetailItemChildText>파티 분담금</PayDetailItemChildText>

          <PayDetailItemChildText>링키드 수수료</PayDetailItemChildText>
        </>

        {data?.log?.deposit ? (
          <PayDetailItemText>보증금 환불</PayDetailItemText>
        ) : null}
      </PayDetailItem>

      {/* value */}
      <PayDetailItem>
        {/* 잔여 파티 요금 환급 */}
        <PayDetailItemText>
          {GetMoneyValue(data?.log?.amount - (data?.log?.deposit ?? 0))}
        </PayDetailItemText>

        <>
          {/* 파티 분담금 */}
          <PayDetailItemGrayText>
            {GetMoneyValue(
              data?.log?.amount - (data?.log?.deposit ?? 0) - data?.log?.comm
            )}
          </PayDetailItemGrayText>

          {/* 링키드 수수료 */}
          <PayDetailItemGrayText>
            {GetMoneyValue(data?.log?.comm)}
          </PayDetailItemGrayText>
        </>

        {/* 보증금 환불 */}
        {data?.log?.deposit > 0 && (
          <PayDetailItemText>
            {GetMoneyValue(data?.log?.deposit)}
          </PayDetailItemText>
        )}
      </PayDetailItem>
    </>
  );
}
